<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">MEDICAL RELEASE FORM</h3>
      <hr>
      <div class="field-of-fields">
        <p>Child's Name: {{ document.field1 }}</p>
        <p>Birthdate: {{ new Date(document.field2).toDateString() }}</p>
        <div style="margin-top: -10px;" v-if="document.status == 'Unsigned'">
          <label style="margin-top: 10px;">Address</label>
          <input type="text" class="form-control" v-model="field3">
          <label style="margin-top: 10px;">Parent's Name</label>
          <input type="text" class="form-control" v-model="field4">
          <label style="margin-top: 10px;">Cell Phone</label>
          <input type="text" class="form-control" v-model="field5">
          <label style="margin-top: 10px;">Child's Doctor</label>
          <input type="text" class="form-control" v-model="field6">
          <label style="margin-top: 10px;">Doctor's Phone</label>
          <input type="text" class="form-control" v-model="field7">
          <label style="margin-top: 10px;">Date of Most Recent Vaccination</label>
          <input type="text" class="form-control" v-model="field8">
          <label style="margin-top: 10px;">Allergies/Medications</label>
          <input type="text" class="form-control" v-model="field9">
          <label style="margin-top: 10px;">Child's Dentist</label>
          <input type="text" class="form-control" v-model="field10">
          <label style="margin-top: 10px;">Dentist's Phone</label>
          <input type="text" class="form-control" v-model="field11">
          <label style="margin-top: 10px;">Manitoba Health Card Number</label>
          <input type="text" class="form-control" v-model="field12">
          <label style="margin-top: 10px;">Emergency Contact and Relation</label>
          <input type="text" class="form-control" v-model="field13">
          <label style="margin-top: 10px;">Emergency Contact Phone</label>
          <input type="text" class="form-control" v-model="field14">
        </div>
        <div v-if="document.status == 'Signed'">
          <p>Address: {{ document.field3 }}</p>
          <p>Parent's Name: {{ document.field4 }}</p>
          <p>Cell Phone: {{ document.field5 }}</p>
          <p>Child's Doctor: {{ document.field6 }}</p>
          <p>Doctor's Phone: {{ document.field7 }}</p>
          <p>Date of Most Recent Vaccination: {{ document.field8 }}</p>
          <p>Allergies/Medications: {{ document.field9 }}</p>
          <p>Child's Dentist: {{ document.field10 }}</p>
          <p>Dentist's Phone: {{ document.field11 }}</p>
          <p>Manitoba Health Card Number: {{ document.field12 }}</p>
          <p>Emergency Contact and Relation: {{ document.field13 }}</p>
          <p>Emergency Contact Phone: {{ document.field14 }}</p>
        </div>
        <pre class="mt-3" style="padding-bottom: 0;" v-html="document.body"></pre>
        <hr>
        <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
        <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
        <h4 v-if="signature" style="font-family: 'Arizonia'">{{ signature }}</h4>
        <h4 v-if="!signature">___________</h4>
        <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
        <div v-if="!document.signing_name">
          <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
          <label class="mt-1">Signature of Parent/Guardian (Please Type)</label>
          <div>
            <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
            <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      field10: '',
      field11: '',
      field12: '',
      field13: '',
      field14: '',
      field15: '',
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',

        field3: this.field3,
        field4: this.field4,
        field5: this.field5,
        field6: this.field6,
        field7: this.field7,
        field8: this.field8,
        field9: this.field9,
        field10: this.field10,
        field11: this.field11,
        field12: this.field12,
        field13: this.field13,
        field14: this.field14,
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/documents/MedicalRelease.vue